import { Link, NavLink, useNavigate } from "react-router-dom";
import bg6 from "../../images/background/bg6.jpg";
import { useEffect } from "react";
import logotext1 from "../../images/logo/logoui2.png";
import { Image } from "antd";
import { useState } from "react";
import { EyeOutlined } from "@ant-design/icons";
import queryString from "query-string";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

const notifyBottomRight = () => {
  toast.success("Actualizamos tu contraseña. Regresando al login", {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  });
};

const fail = () => {
  toast.error("No fue posible actualizar tu contraseña.", {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  });
};

const doubleCheck = () => {
  toast.warning("Las contraseñas ingresadas no coinciden", {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  });
};

const ChangePassword = () => {
  let navigate = useNavigate();
  const [mostrarPassword, setMostrarPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");
  const [payload, setPayload] = useState("");

  const queryStringValues = queryString.parse(window.location.search);
  const payloadURL = queryStringValues.payload;

  useEffect(() => {
    setPayload(payloadURL);
    if (!payloadURL) {
      navigate("/login");
    }
  }, []);

  return (
    <div
      className="bg-img-fix overflow-hidden"
      style={{ background: "#fff url(" + bg6 + ")", height: "100vh" }}
    >
      <div className="container h-100">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-6">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div
                    className="auth-form"
                    style={{ background: "#fff url(" + bg6 + ")" }}
                  >
                    <div className="text-center mb-3">
                      <Link to="/login">
                        <Image src={logotext1} height={25} preview={false} />
                      </Link>
                    </div>
                    <h4 className="text-center mb-4" style={{ color: "white" }}>
                      A continuación ingrese su nueva contraseña
                    </h4>
                    <form
                      onSubmit={async (e) => {
                        e.preventDefault();
                        if (password !== passwordRepeat) {
                          doubleCheck();
                        } else {
                          await axios
                            .put(
                              "http://unioninformatica.org:4000/api/v1/boletaDigital/updatePassword",
                              {
                                body: JSON.stringify({ payload, password }),
                              }
                            )
                            .then((res) => {
                              if (res.status === 200) {
                                notifyBottomRight();
                              } else {
                                fail();
                              }
                            });
                        }
                      }}
                    >
                      <label>Nueva contraseña</label>
                      <div
                        className="form-group mt-3"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <input
                          name="pwd"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          className="form-control"
                          placeholder="Contraseña"
                          type={mostrarPassword ? "text" : "password"}
                        />

                        <div
                          style={{
                            alignItems: "center",
                            marginLeft: "10px",
                            display: "flex",
                          }}
                        >
                          <EyeOutlined
                            onClick={() => setMostrarPassword(!mostrarPassword)}
                          />
                        </div>
                      </div>
                      <label className="mt-3">Repita la contraseña</label>
                      <div
                        className="form-group mt-3"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <input
                          name="pwd-repeat"
                          value={passwordRepeat}
                          onChange={(e) => setPasswordRepeat(e.target.value)}
                          className="form-control"
                          placeholder="Contraseña"
                          type={mostrarPassword ? "text" : "password"}
                        />

                        <div
                          style={{
                            alignItems: "center",
                            marginLeft: "10px",
                            display: "flex",
                          }}
                        >
                          <EyeOutlined
                            onClick={() => setMostrarPassword(!mostrarPassword)}
                          />
                        </div>
                      </div>
                      <div className="text-center">
                        <button
                          style={{ width: "100%" }}
                          type="submit"
                          className="btn btn-primary dz-xs-flex m-r5 mb-2 mt-5"
                        >
                          Confirmar
                        </button>

                        <NavLink
                          type="submit"
                          className="btn btn-secondary btn-block"
                          to="/login"
                        >
                          Volver
                        </NavLink>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ChangePassword;
